import { CheckCircleIcon, NotAllowedIcon } from '@chakra-ui/icons';
import { Flex, Stack, Text } from '@chakra-ui/react';
import { fontSize } from '@constants/styles';

const CoverageOutline = ({ coverage }) => {
  const iconSize = '24px';

  const renderLine = (item) => {
    const icon = item.covered ? (
      <CheckCircleIcon color="green" w={iconSize} h={iconSize} />
    ) : (
      <NotAllowedIcon color="darkred" w={iconSize} h={iconSize} />
    );
    return (
      <Flex alignItems="center" key={item.name}>
        {icon}
        <Text fontSize={fontSize.p} ml={4}>
          {item.name}
        </Text>
      </Flex>
    );
  };

  return (
    <Stack py={4} spacing={4}>
      {coverage.map((item) => renderLine(item))}
    </Stack>
  );
};

export default CoverageOutline;
